const fieldPaths = {
  basePath: "field",
  children: {
    new: "new",
  },
};

export default fieldPaths;
